const terms = {
    adicionarBeneficiario: [
        'adicionar',
        'incluir',
        'cadastrar',
        'adição',
        'inclusão',
        'cadastro',
        'beneficiário',
        'titular',
        'dependente',
        'dependentes',
        'adicionar beneficiário',
        'adicionar titular',
        'adicionar dependente',
        'adicionar vida',
        'novo beneficiário',
        'novo titular',
        'novo dependente',
        'nova vida',
        'novo cadastro',
        'inclusão de beneficiário',
        'inclusão de titular',
        'inclusão de dependente',
        'cadastro de beneficiário',
        'cadastro de titular',
        'cadastro de dependente',
        'cadastrar beneficiário',
        'cadastrar titular',
        'cadastrar dependente',
        'movimentação',
        'movimentações',
        'movimentação cadastral',
    ],

    alterarBeneficiario: [
        'alterar',
        'modificar',
        'atualizar',
        'alteração',
        'modificação',
        'atualização',
        'beneficiário',
        'beneficiários',
        'titular',
        'dependente',
        'alterar titular',
        'alterar dependente',
        'alterar cadastro',
        'cadastro',
        'cadastro de beneficiário',
        'atualizar dados',
        'atualizar cadastro',
        'alterar cadastro',
        'editar cadastro',
        'movimentação',
        'movimentações',
        'movimentação cadastral',
    ],

    alterarSenha: [
        'alterar',
        'senha',
        'alterar senha',
        'alteração',
        'alteração de senha',
        'redefinir',
        'redefinir senha',
        'redefinição de senha',
        'atualizar',
        'atualizar senha',
        'atualização de senha',
        'mudar',
        'mudar senha',
        'mudança',
        'mudança de senha',
        'trocar',
        'trocar senha',
        'troca de senha',
    ],

    aposentadosDemitidos: [
        'aposentado',
        'demitido',
        'aposentados',
        'demitidos',
        'DAP',
        'plano de continuidade',
        'plano continuidade',
        'demissão',
        'aposentadoria',
        'continuidade',
        'continuidade do plano',
        'continuar',
        'continuar com o plano',
        'movimentação',
        'movimentações',
        'movimentação cadastral',
    ],

    cartaReajuste: [
        'carta',
        'reajuste',
        'carta de reajuste',
        'reajuste anual',
        'informações de reajuste',
        'consultar',
        'consulta',
        'documento de reajuste',
    ],

    centroCusto: [
        'centro',
        'custo',
        'centro de custo',
        'centros',
        'custos',
        'centros de custo',
        'cadastro',
        'cadastrar',
        'incluir',
        'inclusão',
        'adição',
        'adicionar',
        'editar',
        'edição',
        'alterar',
        'alteração',
        'consulta',
        'consultar',
        'atualizar',
        'atualização',
        'excluir',
        'exclusão',
        'deletar',
        'novo centro de custo',
        'novo centro',
        'cadastro de centro de custo',
        'cadastrar centro de custo',
        'incluir centro de custo',
        'inclusão de centro de custo',
        'alterar centro de custo',
        'alteração de centro de custo',
        'consultar centro de custo',
        'consulta de centro de custo',
        'ver centro',
        'ver centro de custo',
        'faturamento',
    ],

    consultaPlanosValores: [
        'consultar',
        'consulta',
        'plano',
        'planos',
        'valor',
        'valores',
        'preço',
        'preços',
        'beneficiário',
        'beneficiários',
        'aposentado',
        'aposentados',
        'demitido',
        'demitidos',
        'ativo',
        'ativos',
        'inativo',
        'inativos',
        'DAP',
        'reajuste',
        'informação',
        'informações',
        'dados',
        'informações sobre planos',
        'informações do plano',
        'dados do plano',
        'consultar plano',
        'consultar planos',
        'consultar valor',
        'consultar valores',
        'consultar preço',
        'consultar preços',
        'consulta de plano',
        'consulta de planos',
        'consulta de valor',
        'consulta de valores',
        'consulta de preço',
        'consulta de preços',
        'preços de planos',
        'ver plano',
        'ver planos',
        'ver valores',
        'ver preço',
        'ver preços',
    ],

    consultarBeneficiario: [
        'consultar',
        'beneficiário',
        'beneficiários',
        'consulta',
        'consultar beneficiário',
        'consultar titular',
        'consultar dependente',
        'consulta de beneficiário',
        'dados',
        'dados de beneficiário',
        'dados de titular',
        'dados de dependente',
        'cadastro',
        'informações',
        'informações de beneficiário',
        'informações de titular',
        'informações de dependente',
    ],

    consultarFaturas: [
        'consultar',
        'consulta',
        'fatura',
        'faturas',
        'consultar fatura',
        'consultar faturas',
        'consulta de fatura',
        'consulta de faturas',
        'boleto',
        'boletos',
        'pagamento',
        'pagamentos',
        'faturamento',
        'nota',
        'nota fiscal',
        'notas fiscais',
        'carta',
        'carta de crédito',
        'crédito',
        'vencimento',
        'emissão',
        'valor',
        'valor da fatura',
        'status',
        'status da fatura',
        'relatório',
        'relatórios',
        'kit',
        'baixar fatura',
        'baixar boleto',
    ],

    declaracaoQuitacaoDebitos: [
        'declaração',
        'declarações',
        'quitação',
        'débito',
        'débitos',
        'anual',
        'informe',
        'informe de rendimentos',
        'pagamento',
        'pagamentos',
        'quitação de débito',
        'declaração de quitação',
        'comprovante',
        'comprovante de pagamento',
        'comprovação de pagamento',
        'gerar',
        'gerar declaração',
        'emitir',
        'emitir declaração',
        'declaração de pagamento',
        'declaração de pagamentos',
        'faturamento',
    ],

    desligarBeneficiario: [
        'desligar',
        'beneficiário',
        'beneficiários',
        'desativar',
        'desligar beneficiário',
        'excluir',
        'excluir beneficiário',
        'remover',
        'remover beneficiário',
        'desligar titular',
        'remover titular',
        'excluir titular',
        'desligar dependente',
        'remover dependente',
        'excluir dependente',
        'dependente',
        'movimentação',
        'movimentações',
        'movimentação cadastral',
    ],

    falecimentoTitular: [
        'falecimento',
        'titular',
        'falecimento de titular',
        'remissão',
        'óbito',
        'morte',
        'continuidade',
        'continuar',
        'continuar com o plano',
        'beneficiário',
        'titular',
        'movimentação',
        'movimentações',
        'movimentação cadastral',
    ],

    gerenciarUsuarios: [
        'cadastrar',
        'cadastrar usuário',
        'cadastrar usuários',
        'cadastro de usuário',
        'cadastro de usuários',
        'usuário cadastrado',
        'usuários',
        'novo usuário',
        'novos usuários',
        'perfil de usuário',
        'permissão',
        'permissões',
        'gerenciar',
        'gerenciar usuários',
        'excluir usuário',
        'incluir usuário',
        'usuário auxiliar',
        'auxiliar',
        'usuários auxiliares',
        'permissão de usuário',
        'permissões de usuários',
        'autorização',
        'adicionar usuário',
    ],

    historicoMovimentacao: [
        'histórico',
        'movimentação',
        'movimentações',
        'movimentação cadastral',
        'log',
        'alterações',
        'registro de alterações',
        'registro de movimentações',
        'movimentações anteriores',
        'movimentação anterior',
        'consultar',
        'consulta',
        'consultar histórico',
        'consulta de histórico',
    ],

    home: [
        'home',
        'home logada',
        'acesso rápido',
        'dashboard',
        'painel',
        'minha área',
        'programa de saúde preventiva',
        'saúde preventiva',
        'odontologia preventiva',
        'programa de odontologia preventiva',
    ],

    informacoesCadastro: [
        'meu cadastro',
        'meus dados',
        'cadastro',
        'informações',
        'informações de cadastro',
        'minhas informações',
        'dados de cadastro',
        'dados cadastrais',
        'dados da empresa',
        'informações da empresa',
        'cadastro da empresa',
        'endereço de correspondência',
        'correspondência',
        'atualizar endereço',
        'alterar endereço',
        'endereço da empresa',
        'endereços da empresa',
        'alterar telefone',
        'atualizar telefone',
        'cadastrar telefone',
        'dados básicos',
        'atualizar dados',
        'alterar dados',
    ],

    lotacao: [
        'lotação',
        'lotações',
        'cadastro',
        'cadastrar',
        'incluir',
        'inclusão',
        'adição',
        'adicionar',
        'editar',
        'edição',
        'alterar',
        'alteração',
        'consulta',
        'consultar',
        'atualizar',
        'atualização',
        'excluir',
        'exclusão',
        'deletar',
        'nova lotação',
        'cadastro de lotação',
        'cadastrar lotação',
        'incluir lotação',
        'inclusão de lotação',
        'alterar lotação',
        'alteração de lotação',
        'consultar lotação',
        'consulta de lotação',
        'ver lotação',
        'faturamento',
    ],

    movimentacaoPorArquivo: [
        'movimentação',
        'arquivo',
        'arquivos',
        'movimentação por arquivo',
        'movimentações',
        'movimentação cadastral',
        'importar',
        'importação',
        'importar arquivo',
        'layout',
        'layout de arquivo',
        'layout de importação',
        'enviar',
        'enviar arquivo',
        'envio',
        'envios',
        'envio de arquivo',
        'enviar layout',
        'planilha',
        'planilha de movimentação',
        'planilha de importação',
        'upload',
        'upload de arquivo',
        'carregar arquivo',
        'consultar',
        'consultar envio',
        'consultar envios',
        'consultar retornos de processamento',
        'arquivo importado',
        'arquivo enviado',
        'arquivo processado',
        'arquivo de retorno',
        'arquivos importados',
        'arquivos enviados',
        'arquivos processados',
        'status',
        'status de arquivo',
        'status de movimentação',
        'devolutiva',
        'arquivo de devolutiva',
    ],

    movimentacoesPendentes: [
        'movimentação',
        'movimentações',
        'pendente',
        'pendentes',
        'pendência',
        'pendências',
        'movimentação cadastral',
        'rascunho',
        'consulta',
        'consultar movimentação',
        'consulta de movimentação',
        'status',
        'status de movimentação',
    ],

    reativarBeneficiario: [
        'reativar',
        'reativação',
        'beneficiário',
        'beneficiários',
        'titular',
        'reativar beneficiário',
        'reativar titular',
        'reativar cadastro',
        'cadastro',
        'reativação de cadastro',
        'reativar vida',
        'movimentação',
        'movimentações',
        'movimentação cadastral',
    ],

    relatorioBeneficiarios: [
        'relatório',
        'relatórios',
        'beneficiário',
        'beneficiários',
        'relatório de beneficiário',
        'relatório de beneficiários',
        'relatório de vidas',
        'vidas',
        'bate cadastral',
        'ativos',
        'desligados',
        'inativos',
        'consulta',
        'consultar',
        'consultar relatório',
        'gerar',
        'gerar relatório',
        'emitir',
        'emitir relatório',
        'lista',
        'Lista de beneficiários',
    ],

    segundaViaCarteirinha: [
        'segunda',
        'via',
        'carteirinha',
        'segunda via',
        'segunda via de carteirinha',
        '2a',
        '2a via',
        'carteira',
        'carteiras',
        'carteirinhas',
        'solicitar',
        'solicitar segunda via',
        'solicitar 2a via',
        'solicitar carteirinha',
        'nova carteirinha',
    ],

    transferirBeneficiario: [
        'transferir',
        'trocar',
        'transferência',
        'troca',
        'beneficiário',
        'beneficiários',
        'titular',
        'dependente',
        'contrato',
        'empresa',
        'trocar contrato',
        'trocar empresa',
        'troca de empresa',
        'transferir empresa',
        'transferir contrato',
        'transferência de contrato',
        'transferência de empresa',
        'movimentação',
        'movimentações',
        'movimentação cadastral',
    ],

    trocarPlano: [
        'trocar',
        'troca',
        'mudar',
        'mudança',
        'alterar',
        'alteração',
        'plano',
        'planos',
        'trocar plano',
        'trocar de plano',
        'mudar plano',
        'mudar de plano',
        'alterar plano',
        'troca de plano',
        'mudança de plano',
        'alterar plano',
        'alteração de plano',
        'plano de beneficiário',
        'plano de titular',
        'plano de dependente',
        'beneficiário',
        'titular',
        'dependente',
        'movimentação',
        'movimentações',
        'movimentação cadastral',
    ],
    demonstrativoImpostoRenda: ['demonstrativo', 'imposto', 'renda', 'ir'],
    demonstrativoCoparticipacao: [
        'demonstrativo',
        'coparticipacao',
        'coparticipação',
        'cooparticipação',
        'co-participação',
        'pdf',
    ],
    tabelaFranquia: [
        'beneficiario',
        'franquia',
        'tabela',
        'interodonto',
        'valor',
        'valores',
        'plano',
        'planos',
        'procedimento',
        'procedimentos',
    ],
    solicitacaoGuias: ['solicitacao', 'guias', 'medico', 'beneficiario', 'acidentados', 'registro'],
    pesquisaRede: ['pesquisa de rede', 'rede', 'pesquisa', 'assistencial', 'plano', 'cobertura'],
    consultaBeneficiarioEventual: [
        'agendamento',
        'consulta',
        'agendamento de consulta',
        'agendar consulta',
        'agendar',
        'cancelar consulta',
        'cancelar',
        'cancelamento de consulta',
    ],
    historico: ['historico', 'consulta'],
};

export default terms;
